module.exports = __webpack_public_path__ + "static/media/integral.e3613f72.svg";